import React from 'react';

export default function Contact({ plan }) {
    return (
        <section id="contact" className="text-white py-16 bg-transparent">
            <div className="max-w-6xl mx-auto px-6 flex flex-col gap-8">
                <h1 className="text-2xl font-bold">Plan de scène</h1>
                <div className="flex justify-center">
                    <img
                        src={`https://api.palladium.rocks/images/${plan.src}`}
                        alt="Plan de scène"
                        className="w-full max-w-lg h-auto block rounded-lg"
                        loading="eager"
                    />
                </div>
            </div>
        </section>
    );
}